// Court jurisdiction options + grouping. Pure and dependency-free so the order
// form (webpack) and the Node test suite (CommonJS) share one source of truth.
//
// IMPORTANT: the `value` of every option is what is submitted to the backend and
// stored on the order — grouping must never change these values.

const COURT_JURISDICTIONS = [
  // ── LOCAL – Subject being served IN my area ──────────────────────────────
  { value: "out_of_area_serve_local", label: "⭐ Out-of-Area Client — Subject Located in My Service Area (Court TBD)" },
  // ── RIVERSIDE COUNTY ─────────────────────────────────────────────────────
  { value: "riverside_superior", label: "Riverside County Superior Court – Main (Riverside)" },
  { value: "riverside_banning", label: "Riverside County Superior Court – Banning" },
  { value: "riverside_corona", label: "Riverside County Superior Court – Corona" },
  { value: "riverside_hemet", label: "Riverside County Superior Court – Hemet" },
  { value: "riverside_indio", label: "Riverside County Superior Court – Indio" },
  { value: "riverside_murrieta", label: "Riverside County Superior Court – Murrieta/Southwest" },
  // ── ORANGE COUNTY ────────────────────────────────────────────────────────
  { value: "orange_central", label: "Orange County Superior Court – Central (Santa Ana)" },
  { value: "orange_north", label: "Orange County Superior Court – North (Fullerton)" },
  { value: "orange_west", label: "Orange County Superior Court – West (Westminster)" },
  { value: "orange_harbor", label: "Orange County Superior Court – Harbor (Newport Beach)" },
  // ── SAN BERNARDINO COUNTY ────────────────────────────────────────────────
  { value: "sbcounty_rancho", label: "San Bernardino County Superior Court – Rancho Cucamonga" },
  { value: "sbcounty_ontario", label: "San Bernardino County Superior Court – Ontario" },
  { value: "sbcounty_san_bern", label: "San Bernardino County Superior Court – San Bernardino (Main)" },
  // ── LOS ANGELES COUNTY ───────────────────────────────────────────────────
  { value: "la_central", label: "Los Angeles County Superior Court – Central (Downtown LA)" },
  { value: "la_pomona", label: "Los Angeles County Superior Court – Pomona" },
  { value: "la_norwalk", label: "Los Angeles County Superior Court – Norwalk" },
  { value: "la_west_covina", label: "Los Angeles County Superior Court – West Covina" },
  // ── FEDERAL ──────────────────────────────────────────────────────────────
  { value: "federal_cd_cal", label: "U.S. District Court – Central District of California" },
  { value: "federal_cd_cal_riverside", label: "U.S. District Court – Central District (Riverside Division)" },
  // ── OTHER ────────────────────────────────────────────────────────────────
  { value: "other_tbd", label: "Other / Not Listed — I'll specify in instructions" },
];

// Display groups, derived from the existing value prefixes. Order matters.
const COURT_GROUPS = [
  { label: "Riverside County", match: (v) => v.startsWith("riverside_") },
  { label: "Orange County", match: (v) => v.startsWith("orange_") },
  { label: "San Bernardino County", match: (v) => v.startsWith("sbcounty_") },
  { label: "Los Angeles County", match: (v) => v.startsWith("la_") },
  { label: "Federal", match: (v) => v.startsWith("federal_") },
  { label: "Other", match: () => true }, // catch-all (incl. out_of_area_serve_local, other_tbd)
];

// Group options for <optgroup> rendering. Every option appears exactly once and
// its value is passed through untouched. Empty groups are omitted.
function groupCourts(courts = COURT_JURISDICTIONS) {
  const list = Array.isArray(courts) ? courts : [];
  const groups = COURT_GROUPS.map((g) => ({ label: g.label, options: [] }));
  for (const opt of list) {
    const idx = COURT_GROUPS.findIndex((g) => g.match(String((opt && opt.value) || "")));
    groups[idx === -1 ? groups.length - 1 : idx].options.push(opt);
  }
  return groups.filter((g) => g.options.length > 0);
}

module.exports = { COURT_JURISDICTIONS, COURT_GROUPS, groupCourts };
